package services

data class FunnelEvent(
    val eventType: String,
    val sessionId: String,
    val campaignId: String,
    val leadId: String? = null,
    val payloadJson: String = "{}",
)

interface FunnelEventService {
    suspend fun record(event: FunnelEvent)
    suspend fun flush()
}

class NoopFunnelEventService : FunnelEventService {
    override suspend fun record(event: FunnelEvent) {}
    override suspend fun flush() {}
}

fun FunnelEvent.toJsonPayload(): String {
    fun esc(value: String): String = value.replace("\\", "\\\\").replace("\"", "\\\"")
    return "{" +
        "\"eventType\":\"${esc(eventType)}\"," +
        "\"sessionId\":\"${esc(sessionId)}\"," +
        "\"campaignId\":\"${esc(campaignId)}\"," +
        (leadId?.let { "\"leadId\":\"${esc(it)}\"," } ?: "") +
        "\"payload\":$payloadJson" +
        "}"
}
